module.exports = __webpack_public_path__ + "static/media/Early Dawn.730b7f79.jpg";